__turbopack_context__.v({
  "accordionSlideOverwrite": "otpForm-module-scss-module__nHwPnW__accordionSlideOverwrite",
  "alert": "otpForm-module-scss-module__nHwPnW__alert",
  "emailHighlight": "otpForm-module-scss-module__nHwPnW__emailHighlight",
  "fadeIn": "otpForm-module-scss-module__nHwPnW__fadeIn",
  "fadeOut": "otpForm-module-scss-module__nHwPnW__fadeOut",
  "otpInput": "otpForm-module-scss-module__nHwPnW__otpInput",
  "otpInputError": "otpForm-module-scss-module__nHwPnW__otpInputError",
  "otpInputRow": "otpForm-module-scss-module__nHwPnW__otpInputRow",
  "otpSeparator": "otpForm-module-scss-module__nHwPnW__otpSeparator",
  "otpSlot": "otpForm-module-scss-module__nHwPnW__otpSlot",
  "otpSlotEmpty": "otpForm-module-scss-module__nHwPnW__otpSlotEmpty",
  "otpSlotFilled": "otpForm-module-scss-module__nHwPnW__otpSlotFilled",
  "pinInputWrapper": "otpForm-module-scss-module__nHwPnW__pinInputWrapper",
  "scaleIn": "otpForm-module-scss-module__nHwPnW__scaleIn",
  "scaleOut": "otpForm-module-scss-module__nHwPnW__scaleOut",
  "verificationActions": "otpForm-module-scss-module__nHwPnW__verificationActions",
  "verificationContainer": "otpForm-module-scss-module__nHwPnW__verificationContainer",
  "verificationSubtitle": "otpForm-module-scss-module__nHwPnW__verificationSubtitle",
  "verificationTitle": "otpForm-module-scss-module__nHwPnW__verificationTitle",
  "verifyHeader": "otpForm-module-scss-module__nHwPnW__verifyHeader",
  "zoomIn": "otpForm-module-scss-module__nHwPnW__zoomIn",
  "zoomOut": "otpForm-module-scss-module__nHwPnW__zoomOut",
});
